import { Observable } from 'rxjs';
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { FgiBackEndService } from 'src/app/shared/fgi-back-end.service';
import { Injectable } from "@angular/core";
import { catchError } from 'rxjs/operators';
import { ControleAgendamentoProcessoHonraBatch } from 'src/app/model/controle-agendamento-processo-batch.model';


@Injectable({
  providedIn: 'root'
})
export class AcompanhamentoBatchService extends FgiBackEndService<ControleAgendamentoProcessoHonraBatch> {

  getNewEntity() {
    return new ControleAgendamentoProcessoHonraBatch();
  }

  protected getResourceURL(): string {
    return 'front/controle-agendamento-honra';
  }

  public buscarAgendamentoHonra(params?: any): Observable<ControleAgendamentoProcessoHonraBatch> {
    let options: any = blockUi();
    options.params=params
    return this.http.get(`${this.BASE_URL}`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<ControleAgendamentoProcessoHonraBatch>;
  }

  public buscarPorId (id: number): Observable<ControleAgendamentoProcessoHonraBatch> {
    const options = blockUi();
    return this.http.get(`${this.BASE_URL}/${id}`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<ControleAgendamentoProcessoHonraBatch>;
  }
}
